import React, { lazy } from "react";

import { IEventHandlerProps } from "@faire/retailer/components/Notifications/EventListener";
import { IAddToCartEvent } from "@faire/retailer/events";

export const LazyAddedToCart = lazy<
  React.FC<IEventHandlerProps<IAddToCartEvent>>
>(
  () =>
    import(/* webpackChunkName: "add-to-cart-notification" */ "./AddedToCart")
);
